export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrierungsdaten"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigt"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Öffentlich zugänglich"])}
}